export const localesMap: Record<string, string> = {
  en: "English",
  fr: "Français",
  de: "Deutsch",
  es: "Español",
  nl: "Nederlands",
  it: "Italiano",
  pl: "Polski",
  "zh-TW": "繁體中文",
  "zh-CN": "简体中文",
  pt: "Português",
  "pt-BR": "Português Brasileiro",
  se: "Svenska",
  nb: "Norsk",
  ru: "Русский язык",
  ro: "Limba română",
  ja: "日本語",
  ar: "عربي",
  hi: "हिन्दी",
  ko: "한국어",
};